import React from 'react';
import "bootstrap/dist/css/bootstrap.css";
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import App from './App';
import "./assets/scss/index.scss";
import reportWebVitals from './reportWebVitals';
import { configStore } from './store';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const store = configStore();
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
